module.exports = __webpack_public_path__ + "img/1.e5e825e9.png";